import { useQuery } from '@tanstack/react-query'
import axiosClient from '../../axios'
import type { ShareRole } from './shareBlotCase'

export interface BlotCaseShare {
  id: string
  receiverEmail: string
  role: ShareRole
  jobTitle: string | null
  status: 'pending' | 'accepted' | 'revoked'
  sharedAt: string
}

/**
 * Existing (non-revoked) shares for a case — lets the "Partager le cas"
 * modal warn before re-inviting an email that already has active access
 * (resending silently replaces that recipient's token/link).
 */
export function useBlotCaseShares(caseId: string | undefined, enabled: boolean) {
  return useQuery({
    queryKey: ['blot-analysis', 'shares', caseId],
    enabled: !!caseId && enabled,
    queryFn: async () => {
      const { data } = await axiosClient.get<{ success: boolean; shares: BlotCaseShare[] }>(
        `/blot-analysis/case/${caseId}/shares`,
      )
      return data.shares
    },
  })
}
